// apps/api/src/agenda/temps.ts
// Les heures de l'agenda (M6). Un vernissage est une date civile et des
// heures (`IVernissage`) ; un rendez-vous est un instant. Le fuseau de
// l'agenda est celui de Paris : une seule source de conversion, ici.
export const FUSEAU_AGENDA = 'Europe/Paris';

function decalageMinutes(instant: Date): number {
  const nom =
    new Intl.DateTimeFormat('en-US', { timeZone: FUSEAU_AGENDA, timeZoneName: 'longOffset' })
      .formatToParts(instant)
      .find((morceau) => morceau.type === 'timeZoneName')?.value ?? 'GMT';
  const apparie = /GMT([+-])(\d{2}):(\d{2})/.exec(nom);
  if (!apparie) return 0;
  return (apparie[1] === '-' ? -1 : 1) * (Number(apparie[2]) * 60 + Number(apparie[3]));
}

/** `2026-10-08` + `18:30` à Paris → l'instant UTC. */
export function instantParisRegie(date: string, heure: string): Date {
  const naif = new Date(`${date}T${heure}:00.000Z`);
  const approche = new Date(naif.getTime() - decalageMinutes(naif) * 60_000);
  return new Date(naif.getTime() - decalageMinutes(approche) * 60_000);
}

/** Le jour civil, à Paris, d'un instant : `AAAA-MM-JJ`. */
export function dateCivileParis(instant: Date): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: FUSEAU_AGENDA,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(instant);
}

/** Le jour de Paris qui contient cet instant : [début, fin[. */
export function bornesDuJourParis(instant: Date): { debut: Date; fin: Date } {
  const jour = dateCivileParis(instant);
  const debut = instantParisRegie(jour, '00:00');
  const lendemain = new Date(`${jour}T12:00:00.000Z`);
  lendemain.setUTCDate(lendemain.getUTCDate() + 1);
  return { debut, fin: instantParisRegie(lendemain.toISOString().slice(0, 10), '00:00') };
}
